import React from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../i18n";

export default function Layout() {
    const location = useLocation();
    const { t } = useLanguage();
    const isAdmin = location.pathname.startsWith("/admin");
    const showStickyCTA = !["/appointment", "/contact"].includes(location.pathname) && !isAdmin;

    if (isAdmin) return <Outlet />;

    return (
        <div className="flex min-h-screen flex-col bg-white">
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            {showStickyCTA && (
                <div className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-white/95 p-3 backdrop-blur-md lg:hidden" data-testid="mobile-sticky-cta">
                    <Link to="/appointment" data-testid="sticky-book-appointment-btn"
                        className="flex items-center justify-center gap-2 rounded-full bg-navy px-5 py-3.5 text-sm font-semibold text-white">
                        <CalendarCheck className="h-4 w-4" aria-hidden="true" />
                        {t("book_appointment")}
                    </Link>
                </div>
            )}
        </div>
    );
}
